export default __webpack_public_path__ + "static/media/rancho2big.41ddfa61.jpg";